<template>
  <div class="fill-height mouse-cursor">
    <v-container v-if="loading" fill-height>
      <v-row>
        <v-col>
          <v-progress-circular indeterminate />
        </v-col>
      </v-row>
    </v-container>

    <v-container v-else-if="trainingCertificate" fill-height>
      <v-row justify="center" align="center" class="pa-4 pa-sm-8">
        <!--congratulations card on training complete-->
        <v-col v-if="!isPublicCourseCertificate" cols="12" md="9">
          <v-card flat class="pa-4">
            <!--gif image-->
            <v-row justify="center" align="center">
              <v-img
                src="@/app/course-module/assets/images/congrats.gif"
                :alt="$t('course.congratulations')"
                max-width="250"
                cover
              >
              </v-img>
            </v-row>

            <!--congrats-->
            <v-row justify="center" align="center">
              <v-col>
                <span class="text-h4 font-weight-bold textLight--text">
                  {{ $t("course.congratulations") }}!
                </span>
              </v-col>
            </v-row>

            <!--congrats message-->
            <v-row justify="center" align="center" class="mb-4">
              <v-col>
                <p class="subtitle-2 textLight--text ma-0">
                  {{ $t("course.courseCompleteCongratulationsMessage") }}
                </p>

                <p class="subtitle-2 textLight--text ma-0">
                  "{{ getLocalisedValue(trainingCertificate.trainingTitle) }}"
                </p>
              </v-col>
            </v-row>

            <!--certificate download button-->
            <v-row justify="center" align="center" class="mb-4">
              <v-col>
                <v-btn
                  depressed
                  outlined
                  color="textLight"
                  :block="!$vuetify.breakpoint.smAndUp"
                  :min-width="$vuetify.breakpoint.smAndUp ? 400 : 0"
                  class="
                    subtitle-1
                    font-weight-medium
                    text-capitalize
                    py-5
                    rounded-2
                  "
                  :loading="downloadTrainingCertificateLoading"
                  @click="downloadTrainingCertificateAsPdf"
                >
                  <v-icon size="14" class="me-1"> mdi-download </v-icon>
                  {{ $t("course.downloadCertificate") }}
                </v-btn>
              </v-col>
            </v-row>

            <!--feedback form deprecated-->
            <!--                        <div v-if="canShowFeedbackForm" class="mx-sm-6 mx-md-10">
                          <v-divider class="my-16"></v-divider>

                          <v-row justify="center" align="center">
                            <v-col cols="auto">
                              <span class="subtitle-1 font-weight-bold textLight&#45;&#45;text">
                                {{ $t("course.certificate.howSatisfied") }}
                              </span>
                            </v-col>
                          </v-row>

                          &lt;!&ndash;feedback satisfaction emoji&ndash;&gt;
                          <v-row justify="center" align="center" class="mb-10">
                            <v-col cols="auto">
                              <v-btn
                                v-for="(satisfaction, satisfactionIndex) in satisfactions"
                                :key="`satisfaction_emoji_${satisfactionIndex}`"
                                width="60"
                                height="60"
                                :color="
                                  satisfaction.name ===
                                  trainingRegistrationFeedback.satisfaction
                                    ? 'button'
                                    : 'transparent'
                                "
                                :depressed="
                                  satisfaction.name !==
                                  trainingRegistrationFeedback.satisfaction
                                "
                                @click="
                                  trainingRegistrationFeedback.satisfaction =
                                    satisfaction.name;
                                  trainingRegistrationFeedback.satisfactionEmoji =
                                    satisfaction.emoji;
                                "
                                class="mx-3"
                                style="font-size: 36px"
                              >
                                {{ satisfaction.emoji }}
                              </v-btn>
                            </v-col>
                          </v-row>

                          <v-row justify="center" align="center" class="mb-3">
                            <v-col>
                              <span class="subtitle-1 font-weight-bold textLight&#45;&#45;text">
                                {{ $t("course.certificate.howLikelyRecommend") }}
                              </span>
                            </v-col>
                          </v-row>

                          &lt;!&ndash;feedback recommend rating&ndash;&gt;
                          <v-row>
                            <v-col class="py-0">
                              <v-slider
                                v-model="trainingRegistrationFeedback.recommendation"
                                min="1"
                                max="10"
                                step="1"
                                ticks
                                thumb-label="always"
                                :tick-labels="tickLabels"
                                track-color="#281166"
                              />
                            </v-col>
                          </v-row>

                          <v-row justify="center" align="center" class="mb-16">
                            <v-col class="text-start py-0">
                              <span class="caption textLight&#45;&#45;text">
                                👎{{ $t("course.certificate.notLikely") }}
                              </span>
                            </v-col>

                            <v-col class="text-end py-0">
                              <span class="caption textLight&#45;&#45;text">
                                👍{{ $t("course.certificate.extremeLikely") }}
                              </span>
                            </v-col>
                          </v-row>

                          &lt;!&ndash;feedback comments&ndash;&gt;
                          <v-row justify="center" align="center">
                            <v-col>
                              <v-textarea
                                v-model="trainingRegistrationFeedback.comments"
                                auto-grow
                                background-color="transparent"
                                flat
                                full-width
                                hide-details="auto"
                                outlined
                                :hint="$t('course.certificate.anyComments')"
                                persistent-hint
                                row-height="24"
                                rows="5"
                                class="rounded-2"
                              />
                            </v-col>
                          </v-row>

                          &lt;!&ndash;feedback submit button&ndash;&gt;
                          <v-row justify="end" align="center" class="mb-sm-3 mb-md-5">
                            <v-col cols="auto">
                              <v-btn
                                depressed
                                color="textLight"
                                min-width="120"
                                class="subtitle-2 font-weight-medium rounded-2 white&#45;&#45;text"
                                :loading="submittingFeedback"
                                @click="updateTrainingRegistrationFeedback"
                              >
                                {{ $t("submit") }}
                              </v-btn>
                            </v-col>
                          </v-row>
                        </div>-->

            <CourseFeedbackForm
              :trainingRegistrationId="
                trainingCertificate.trainingRegistration._id
              "
              :trainingRegistrationData="
                trainingCertificate.trainingRegistration
              "
              :outlined="true"
            />
          </v-card>
        </v-col>

        <!--viewing page by other means-->
        <v-col v-else-if="downloadTrainingCertificateHtml">
          <v-card flat color="transparent">
            <div
              style="display: flex; flex-direction: column; align-items: center"
            >
              <!--              <v-toolbar
                v-if="canDownload"
                flat
                dense
                :width="
                  previewTrainingCertificateHeight *
                  trainingCertificateAspectRatio
                "
                class="mb-2"
              >
                <v-toolbar-title>
                  {{ $t("user.profile.downloadMyCertificate") }}
                </v-toolbar-title>

                <v-spacer />

                <v-toolbar-items v-if="downloadTrainingCertificateHtml">
                  <v-btn
                    icon
                    :loading="downloadTrainingCertificateLoading"
                    @click="downloadTrainingCertificateAsPdf"
                  >
                    <v-icon> mdi-file-pdf-box </v-icon>
                  </v-btn>

                  &lt;!&ndash;                  <v-btn
                    icon
                    :loading="downloadTrainingCertificateLoading"
                    @click="downloadTrainingCertificateAsImage"
                  >
                    <v-icon> mdi-image </v-icon>
                  </v-btn>&ndash;&gt;
                </v-toolbar-items>
              </v-toolbar>-->

              <!--              <div v-html="downloadTrainingCertificateHtml"></div>-->

              <!--              <iframe
                :src="previewCertificateUri + '#toolbar=0&navpanes=0'"
                :width="previewCertificateSize.width"
                :height="previewCertificateSize.height"
                frameborder="0"
              />-->

              <vue-pdf-embed
                :source="previewCertificateUri"
                :height="previewTrainingCertificateHeight"
              />
            </div>
          </v-card>

          <!--certificate download button-->
          <v-row
            v-if="canDownload"
            justify="center"
            align="center"
            class="my-4"
          >
            <v-col>
              <v-btn
                depressed
                outlined
                color="textLight"
                class="
                  subtitle-1
                  font-weight-medium
                  text-capitalize
                  py-5
                  rounded-2
                "
                :loading="downloadTrainingCertificateLoading"
                @click="downloadTrainingCertificateAsPdf"
              >
                <v-icon size="14" class="me-1"> mdi-download </v-icon>
                {{ $t("course.downloadCertificate") }}
              </v-btn>
            </v-col>
          </v-row>
        </v-col>
      </v-row>
    </v-container>

    <v-container v-else fill-height>
      <Error />
    </v-container>

    <v-snackbar v-model="snackbar" timeout="3000">
      {{ $t("somethingWentWrong") }}

      <template v-slot:action="{ attrs }">
        <v-btn color="primary" text v-bind="attrs" @click="snackbar = false">
          {{ $t("close") }}
        </v-btn>
      </template>
    </v-snackbar>

    <v-dialog
      v-if="trainingCertificate"
      v-model="downloadTrainingCertificateDialog"
      :width="previewTrainingCertificateHeight * 3"
      :fullscreen="$vuetify.breakpoint.xsOnly"
    >
      <v-card flat color="grey" class="mouse-cursor">
        <v-toolbar>
          <v-btn icon @click="downloadTrainingCertificateDialog = false">
            <v-icon>mdi-close</v-icon>
          </v-btn>

          <v-toolbar-title>
            {{ $t("user.profile.downloadMyCertificate") }}
          </v-toolbar-title>

          <v-spacer />

          <v-toolbar-items v-if="downloadTrainingCertificateHtml">
            <v-btn
              icon
              :loading="downloadTrainingCertificateLoading"
              @click="downloadTrainingCertificateAsPdf"
            >
              <v-icon> mdi-file-pdf-box </v-icon>
            </v-btn>

            <!--            <v-btn
              icon
              :loading="downloadTrainingCertificateLoading"
              @click="downloadTrainingCertificateAsImage"
            >
              <v-icon> mdi-image </v-icon>
            </v-btn>-->
          </v-toolbar-items>
        </v-toolbar>

        <v-card
          v-if="downloadTrainingCertificateHtml"
          flat
          color="grey"
          :min-height="previewTrainingCertificateHeight"
          class="py-6 rounded-0"
        >
          <div
            style="display: flex; flex-direction: column; align-items: center"
          >
            <div v-html="downloadTrainingCertificateHtml"></div>
          </div>
        </v-card>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import VuePdfEmbed from "vue-pdf-embed/dist/vue2-pdf-embed";
import Error from "../../core-module/components/Error";
import CourseFeedbackForm from "@/app/course-module/components/CourseFeedbackForm";

import {
  bulkDownloadTrainingCertificates,
  generateTrainingCertificatePdf,
} from "@/app/user-module/helpers/certificateHelper";
import { updateGetProfileCache } from "@/app/course-module/methods/updateTrainingProgress";
import { getTrainingCertificateHtmlTemplate } from "@/app/course-module/helpers/certificatePreviewHelper";

// import { updateTrainingRegistrationFeedback } from "@/app/course-module/methods/updateTrainingRegistrationFeedback";
//
// const getDefaultTrainingRegistrationFeedback = () => {
//   return {
//     satisfaction: "BEST",
//     satisfactionEmoji: "🤩",
//     recommendation: 9,
//     comments: "",
//   };
// };

export default {
  name: "CourseCertificate",
  components: { VuePdfEmbed, CourseFeedbackForm, Error },
  data() {
    return {
      loading: true,
      trainingCertificate: null,
      subscriberInfo: null,
      downloadTrainingCertificateDialog: false,
      downloadTrainingCertificateLoading: false,
      // downloadTrainingCertificateHtml: null,
      downloadTrainingCertificateHeight: 600,
      trainingCertificateAspectRatio: 1.41,
      // submittingFeedback: false,
      snackbar: false,
      // satisfactions: [
      //   { name: "BAD", emoji: "🙁" },
      //   { name: "GOOD", emoji: "🙂" },
      //   { name: "BEST", emoji: "🤩" },
      // ],
      // trainingRegistrationFeedback: getDefaultTrainingRegistrationFeedback(),
    };
  },
  computed: {
    isPublicCourseCertificate() {
      return (
        this.$route.name === "CourseCertificate" ||
        this.$route.name === "PublicCourseCertificate" ||
        this.trainingCertificate?.employee?.user?._id !==
          this.$store.state.authenticatedUser?._id
      );
    },
    canDownload() {
      return (
        this.$route.name === "CourseCertificate" &&
        this.$store.state.authenticatedUser?._id &&
        this.trainingCertificate?.employee?.user?._id ===
          this.$store.state.authenticatedUser?._id
      );
    },
    previewTrainingCertificateHeight() {
      const lowestSize = Math.min(
        this.$vuetify.breakpoint.width,
        this.$vuetify.breakpoint.height
      );

      const relativeHeight =
        (lowestSize * 0.8) / this.trainingCertificateAspectRatio;

      return this.isPublicCourseCertificate
        ? relativeHeight
        : Math.min(300, relativeHeight);
    },
    downloadTrainingCertificateHtml() {
      return getTrainingCertificateHtmlTemplate({
        trainingCertificate: this.trainingCertificate,
        subscriberInfo:
          this.subscriberInfo ?? this.trainingCertificate.subscriberInfo,
        height: this.previewTrainingCertificateHeight,
      });
    },
    previewCertificateSize() {
      const aspectRatio = 842 / 595;

      const relativeWidth =
        Math.min(
          this.$vuetify.breakpoint.width,
          this.$vuetify.breakpoint.height
        ) * 0.85;

      return {
        width: relativeWidth,
        height: relativeWidth / aspectRatio,
      };
    },
    previewCertificateUri() {
      return (
        generateTrainingCertificatePdf({
          trainingCertificates: [this.trainingCertificate],
          subscriberInfo:
            this.subscriberInfo ?? this.trainingCertificate.subscriberInfo,
          dataUriString: true,
        }) ?? ""
      );
    },
    // canShowFeedbackForm() {
    //   return (
    //     !this.trainingCertificate?.trainingRegistration?.feedback &&
    //     this.trainingCertificate?.employee?.user?._id ===
    //       this.$store.state.authenticatedUser?._id
    //   );
    // },
    // tickLabels() {
    //   return [...Array(10).keys()].map(x => (x + 1).toString());
    // },
  },
  apollo: {
    getSubscriberProfile() {
      return {
        query: require("../../user-module/api/query/getSubscriberProfile.gql"),
        result({ data }) {
          if (data?.getSubscriberProfile) {
            this.subscriberInfo = data.getSubscriberProfile;
          }
        },
      };
    },
  },
  created() {
    this.$apollo.addSmartQuery("getTrainingCertificate", {
      query: require("../api/query/getTrainingCertificate.gql"),
      variables: {
        id: this.$route.params.id,
      },
      result({ data, loading }) {
        if (data && data.getTrainingCertificate) {
          this.trainingCertificate = data.getTrainingCertificate;

          if (!this.isPublicCourseCertificate) {
            updateGetProfileCache(data.getTrainingCertificate);
          }
          // if (data.getTrainingCertificate?.trainingRegistration?.feedback) {
          //   this.trainingRegistrationFeedback =
          //     data.getTrainingCertificate?.trainingRegistration?.feedback;
          // }
        }

        this.loading = loading;
      },
    });
  },
  methods: {
    previewTrainingCertificate() {
      if (this.downloadTrainingCertificateDialog) return;
      // this.downloadTrainingCertificateLoading = true;

      // this.downloadTrainingCertificateHtml =
      //   getTrainingCertificateHtmlTemplate({
      //     trainingCertificate: this.trainingCertificate,
      //     height: this.previewTrainingCertificateHeight,
      //   });

      // this.downloadTrainingCertificateLoading = false;
      this.downloadTrainingCertificateDialog = true;

      // for testing
      // this.downloadHtmlAsImage({
      //   htmlTemplate,
      //   download: true,
      //   dataList: [
      //     {
      //       elementId: "card-front-side",
      //       fileName: `my-card-front-${Date.now()}`,
      //     },
      //   ],
      // });
    },
    async downloadTrainingCertificateAsPdf() {
      if (this.downloadTrainingCertificateLoading) return;
      this.downloadTrainingCertificateLoading = true;

      // for testing
      // await this.printHtmlAsPdf({
      //   htmlTemplate: `
      //       <div style="display: flex;flex-direction: column; align-items: center;">
      //           ${document.getElementById("training-certificate-front-back").innerHTML}
      //       </div>
      //   `,
      // });

      await bulkDownloadTrainingCertificates({
        trainingCertificates: [this.trainingCertificate],
        subscriberInfo:
          this.subscriberInfo ?? this.trainingCertificate.subscriberInfo,
      });

      // await this.downloadHtmlAsPdf({
      //   imageWidth:
      //     this.downloadTrainingCertificateHeight *
      //     this.trainingCertificateAspectRatio,
      //   imageHeight: this.downloadTrainingCertificateHeight,
      //   imageScaling: 6,
      //   data: {
      //     htmlElement: document.getElementById(
      //       "training-certificate-front-back"
      //     ),
      //     elementId: "training-certificate-front-back",
      //     fileName: `my-certificate-${Date.now()}`,
      //   },
      //   orientation: "landscape",
      // });

      this.downloadTrainingCertificateLoading = false;
    },
    async downloadTrainingCertificateAsImage() {
      if (this.downloadTrainingCertificateLoading) return;
      this.downloadTrainingCertificateLoading = true;

      await this.downloadHtmlAsImage({
        imageWidth:
          this.downloadTrainingCertificateHeight *
          this.trainingCertificateAspectRatio,
        imageHeight: this.downloadTrainingCertificateHeight,
        imageScaling: 2,
        dataList: [
          {
            htmlElement: document.getElementById(
              "training-certificate-front-back"
            ),
            elementId: "training-certificate-front-back",
            fileName: `my-certificate-${Date.now()}`,
          },
        ],
      });

      this.downloadTrainingCertificateLoading = false;
    },
    // updateTrainingRegistrationFeedback() {
    //   if (this.submittingFeedback) return;
    //   this.submittingFeedback = true;
    //
    //   updateTrainingRegistrationFeedback({
    //     id: this.trainingCertificate?.trainingRegistration?._id,
    //     input: this.trainingRegistrationFeedback,
    //   }).then(response => {
    //     if (response.data) {
    //       this.trainingRegistrationFeedback =
    //         getDefaultTrainingRegistrationFeedback();
    //     } else if (response.error) this.snackbar = true;
    //
    //     this.submittingFeedback = false;
    //   });
    // },
  },
};
</script>

<style lang="scss" scoped />
